import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import TextField from '../common/form/text-field/index';
import Button from 'material-ui/Button';

const styles = theme => ({
	root: {
		minWidth: 300,
		maxWidth: 320,
		margin: '64px auto 0',
		alignSelf: 'center'
	},
	generalErrorNotification: {
		color: theme.palette.error[500],
		textAlign: 'center'
	},
	formActions: {
		marginTop: theme.spacing.unit * 3
	}
});

const LoginForm = props => {
	const {
		classes,
		handleSubmit,
		setFieldValue,
		setFieldTouched,
		isAuthPending,
		isSessionExpired,
		isAuthUnconfirmed,
		values,
		errors,
		touched
	} = props;

	const textFieldProps = {
		setFieldValue,
		setFieldTouched,
		values,
		errors,
		touched
	};

	return (
		<div className={classes.root}>
			<form onSubmit={handleSubmit}>
				<TextField
					margin="normal"
					fullWidth
					label="Email"
					name="email"
					{...textFieldProps}
				/>
				<TextField
					margin="normal"
					fullWidth
					label="Password"
					name="password"
					type="password"
					{...textFieldProps}
				/>
				<div className={classes.formActions}>
					<Button raised color="primary" type="submit" disabled={isAuthPending}>
						Log In
					</Button>
				</div>
			</form>
			{isSessionExpired && (
				<div className={classes.generalErrorNotification}>
					<p> We are sorry, your session has been expired </p>
				</div>
			)}
			{isAuthUnconfirmed && (
				<div className={classes.generalErrorNotification}>
					<p> We are sorry, but your user is not confirmed as admin user </p>
				</div>
			)}
		</div>
	);
};

LoginForm.propTypes = {
	classes: PropTypes.object.isRequired,
	handleSubmit: PropTypes.func.isRequired,
	setFieldValue: PropTypes.func.isRequired,
	setFieldTouched: PropTypes.func.isRequired,
	values: PropTypes.object.isRequired,
	errors: PropTypes.object.isRequired,
	touched: PropTypes.object.isRequired,
	isAuthPending: PropTypes.bool.isRequired,
	isSessionExpired: PropTypes.bool,
	isAuthUnconfirmed: PropTypes.bool
};

LoginForm.defaultProps = {
	isSessionExpired: false
};

export default withStyles(styles)(LoginForm);



// WEBPACK FOOTER //
// ./src/client/components/admin/login-form/login-form.jsx